<template>
  <customModal :containermd="true" :footerShow="true" @closeModal="$emit('close')">
    <template #title>
      {{ $t("navigations.assign lab test") }}
    </template>

    <template #body>
      <!-- Loader -->
      <div class="text-center" v-if="showLoading">
        <img src="../../assets/img/loading.gif" width="15" alt="Loading" />
        <div>{{ $t("navigations.please wait while the list is being loaded") }}</div>
      </div>

      <!-- Table -->
      <template v-else>
        <div class="text-center" v-if="labList.length === 0">
          {{ $t("navigations.no data available") }}
        </div>

        <div v-else class="table-responsive mt-3">
          <table class="table table-striped table-bordered dataTables">
            <thead>
              <tr>
                <th>
                  <div class="d-flex align-items-center gap-1">
                    <input type="checkbox" v-model="selectAll" @change="toggleSelectAll" />
                    <span>{{ $t("navigations.select all") }}</span>
                  </div>
                </th>

                <th @click="SortSelected('testCode')"
                  :class="{ sortAsc: SortProperty === 'testCode' && SortOrder, sortDesc: SortProperty === 'testCode' && !SortOrder }">
                  {{ $t("navigations.test code") }}
                  <span>
                    <i class="fa fa-long-arrow-up"></i>
                    <i class="fa fa-long-arrow-down"></i>
                  </span>
                </th>
                <th @click="SortSelected('testName')"
                  :class="{ sortAsc: SortProperty === 'testName' && SortOrder, sortDesc: SortProperty === 'testName' && !SortOrder }">
                  {{ $t("navigations.test name") }}
                  <span>
                    <i class="fa fa-long-arrow-up"></i>
                    <i class="fa fa-long-arrow-down"></i>
                  </span>
                </th>

                <th>{{ $t("navigations.unit") }}</th>
                <th>{{ $t("navigations.category") }}</th>
                <th>{{ $t("navigations.method") }}</th>
                <th>{{ $t("navigations.cdisc variable") }}</th>
                <th>{{ $t("navigations.fhir resource") }}</th>

              </tr>
            </thead>
            <tbody>
              <tr v-for="lab in labList" :key="lab.testId || lab.id">
                <td class="text-center">
                  <input type="checkbox" v-model="lab.selected" />
                </td>
                <td>{{ lab.testCode }}</td>
                <td>{{ lab.testName }}</td>
                <td>{{ lab.unit }}</td>
                <td>{{ lab.category }}</td>
                <td>{{ lab.method }}</td>
                <td>{{ lab.cdiscVariable }}</td>
                <td>{{ lab.fhirResource }}</td>

              </tr>
            </tbody>
          </table>
          <div class="col-md-12 d-flex justify-content-md-end px-0" v-if="labList.length > 0">
            <VPagination v-model="currentPage" :pages="totalPage" :range-size="1" active-color="#ededed"
              @update:modelValue="loadPage" />
          </div>

          <!-- Save Button -->
          <!-- <div class="text-right mt-3">
            <button type="button" class="btn btn-primary btn-sm py-0 px-3 mt-2" @click="saveSelectedTests">
              {{ $t("navigations.save") }}
            </button>
          </div> -->
        </div>
      </template>
    </template>
    <template #footer>
      <div class="float-right py-1 float-right">
      <button type="button" class="btn btn-primary btn-sm py-0 px-3" @click="saveSelectedTests">
        {{ $t("navigations.save") }}
      </button>
      </div>
    </template>
  </customModal>
</template>
<script src="./assignTestModal.js"></script>


<style scoped>

.edit-delete {
  cursor: pointer;
  color: #1ab394;
}

.edit-delete:hover {
  color: #117a65;
}
</style>
